import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EstoqueHistorico } from '../models/estoque-historico';

@Injectable({
  providedIn: 'root',
})
export class EstoqueHistoricoService {
  //Url da API

  private url = `${environment.apiUrl}/historico`;

  constructor(private http: HttpClient) {}

  selecionar(): Observable<EstoqueHistorico[]> {
    return this.http.get<EstoqueHistorico[]>(this.url);
  }
}
